<template>
  <div fluid>
    <HeaderBar>
      <v-icon slot="icon">add</v-icon>
      Add Client Business Location
    </HeaderBar>

    <v-layout row>
      <v-flex>
        <p class="subtle">
          You are creating a new parent business. If you're trying to add
          another worksite location to an existing business, please click on
          them in
          <router-link :to="{ name: 'hrClientBusinesses' }"
            >the index</router-link
          >
          and add the new location to their page.
        </p>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex grow class="mr-2">
        <v-layout column>
          <h2 class="headline">Parent Business</h2>
          <v-layout row class="mb-2">
            <v-flex class="mr-2">
              <v-text-field
                v-model="clientBusiness.name"
                label="Business Name"
                persistent-hint
                hint="Use the same name as the work site location if this business only has one location"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <h2 class="headline mt-4">Work site location</h2>
          <v-layout row>
            <v-flex class="mr-2">
              <v-text-field
                v-model="worksite.name"
                label="Location Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex class="mr-2">
              <v-text-field
                v-model="worksite.street_address"
                label="Street Address"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex class="mr-2">
              <v-text-field v-model="worksite.city" label="City"></v-text-field>
            </v-flex>
            <v-flex class="mr-2">
              <v-autocomplete
                v-model="worksite.state"
                label="State"
                :items="states"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="mr-2">
              <v-text-field v-model="worksite.zip" label="Zip"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex class="mr-2">
              <v-text-field
                v-model="worksite.phone"
                label="Phone"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex class="mr-2">
              <v-autocomplete
                :items="geotagStates"
                label="Add this workstie location to Geo Tag (not required)"
                v-model="worksiteGeotagSelection"
                clearable
                class="mr-2"
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-flex class="mt-4">
            <h2 class="headline">
              Add Employees by Geo Tag (<span class="subtle">not required</span
              >)
            </h2>
            <v-autocomplete
              :items="geotagStates"
              label="Geo Tags"
              v-model="geotagSelection"
              clearable
              class="mr-2"
            >
            </v-autocomplete>
          </v-flex>
        </v-layout>
        <p class="subtle mt-4">
          You will be able to add all other details after saving
        </p>
      </v-flex>

      <v-flex shrink>
        <v-layout column>
          <v-flex>
            <v-btn
              @click="createClientBusiness"
              block
              :loading="apiCallPending"
              :disabled="!newBusinessValid || apiCallPending"
              color="success"
            >
              Save &amp; Create
            </v-btn>
          </v-flex>
          <v-flex>
            <v-btn
              :to="{ name: 'hrClientBusinesses' }"
              block
              color="error"
              :disabled="apiCallPending"
            >
              Cancel
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import HeaderBar from "@/components/base/header-bar.vue";
import collectionsApi from "@/api/collections";

export default {
  components: {
    HeaderBar
  },
  created() {
    this.setUp();
  },
  watch: {},
  computed: {
    ...mapState("userAuth", ["user"]),
    newBusinessValid() {
      return (
        this.clientBusiness.name &&
        this.worksite.name &&
        this.worksite.street_address &&
        this.worksite.city &&
        this.worksite.state &&
        this.worksite.zip &&
        this.worksite.country &&
        this.worksite.phone
      );
    }
  },
  methods: {
    setUp() {
      collectionsApi.getGeotagStates({}, states => {
        this.geotagStates = states;
      });
    },
    createClientBusiness() {
      this.apiCallPending = true;
      this.$store
        .dispatch("clientBusinesses/create", {
          clientBusiness: this.clientBusiness,
          worksite: this.worksite,
          geotagSelection: this.geotagSelection,
          worksiteGeotagSelection: this.worksiteGeotagSelection
        })
        .then(clientBusiness => {
          this.apiCallPending = false;
          const message = `Created Business ${clientBusiness.name}!`;
          this.$store.dispatch("global/showSnackbarSuccess", {
            message: message
          });
          this.$router.push({
            name: "clientBusinessDetail",
            params: { clientBusinessId: clientBusiness.id }
          });
        })
        .catch(e => {
          this.apiCallPending = false;
          const message = `Something went wrong creating that business...`;
          this.$store.dispatch("global/showSnackbarError", {
            message: message
          });
        });
    }
  },
  data: function() {
    return {
      apiCallPending: false,
      states: collectionsApi.getStates(),
      geotagStates: [],
      geotagSelection: null,
      worksiteGeotagSelection: null,
      clientBusiness: {
        name: ""
      },
      worksite: {
        name: "",
        street_address: "",
        city: "",
        state: "",
        zip: "",
        country: "USA",
        phone: ""
      }
    };
  }
};
</script>
